module.exports = __webpack_public_path__ + "media/images/channels/neurosurgery-9b80ef5ddcf7cf9173b95dc8768001e2.jpg";